import {   IBlogAuthor } from '../../interfaces'
import { CountryCode } from '../../lib/constants'
import { NavLink } from '../ui'
import Image from 'next/image'
import styles from './Trends.module.css'
import { cmsLoader } from '../../lib/helpers/imageLoader'
type Props = {
    countryCode:CountryCode
    authors:IBlogAuthor[]
  }
  export function TopAuthors({countryCode,authors}:Props ){
      const siteURL=process.env.SITE_URL+"/"+countryCode;  
    return (
        <section className={styles.trendsTopAuthors}>         
        <div className="container">
            <h2 className="text222 font26 mb46 textCenter">Top Authors</h2>
            <div className={styles.topAutorBox}>
                {authors && authors.map((authors:IBlogAuthor,index:number)=>
                <NavLink  key={index} href={`${siteURL}/trends/author/${authors.slug}`}>
                <div className={styles.topAutorTiles}>                   
                    <Image className="img-responsive" src={authors.RelativePath} loader={cmsLoader} width={41} height={41} alt={authors.name}/>
                    <div className="topAutortext">
                        <span className="font12 text000">{authors.name}</span>
                        <p className="font10 text666">{`${authors.postCount} Stories`}</p>
                    </div>
                </div></NavLink>)}
            </div>
        </div>
    
       </section>
    );
}